// useGeneralSourceConfigured.js
//
// The General (BYOD) agent is special: unlike every other Agent Space agent it
// has NO OAuth connection. Its "configured" state depends entirely on whether a
// data SOURCE has been set up (agent_space_general_sources). Status chips that
// derive readiness from `requires_connection` therefore report the General
// agent as ready/active by default — which is wrong before a source is picked.
//
// This hook centralises that check so every status surface (Landing, Dashboard,
// Agent Detail, Settings, Info Panel) can override isConfigured for the
// 'general' agent from one place instead of duplicating the fetch.
//
// Returns true once a source row with a source_type exists, else false.
import { useEffect, useState } from 'react';
import axiosInstance from '../../../../utils/axiosInstance';

export default function useGeneralSourceConfigured(chatbotId, { enabled = true, refreshKey } = {}) {
    const [configured, setConfigured] = useState(false);

    useEffect(() => {
        if (!enabled || !chatbotId) {
            setConfigured(false);
            return undefined;
        }
        let cancelled = false;
        axiosInstance
            .get(`/api/agent-space/general/source?chatbot_id=${chatbotId}`)
            .then((res) => {
                if (cancelled) return;
                const src = res.data?.data;
                setConfigured(!!(src && src.source_type));
            })
            .catch(() => { if (!cancelled) setConfigured(false); });
        return () => { cancelled = true; };
    }, [chatbotId, enabled, refreshKey]);

    return configured;
}
